import { render, staticRenderFns } from "./UsageSituation.vue?vue&type=template&id=081fe62a&scoped=true&"
import script from "./UsageSituation.vue?vue&type=script&lang=js&"
export * from "./UsageSituation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081fe62a",
  null
  
)

export default component.exports